export function updateCannedMessages(cannedMessages) {
  return {
    type: 'UPDATE_CannedMessages',
    cannedMessages: cannedMessages
  }
}

export function updateTaskContexts(taskContexts) {
  return {
    type: 'UPDATE_TaskContext',
    taskContext: taskContexts
  }
}

export function updateTaskQueuesList(taskQueueList) {
  return {
    type: 'UPDATE_TaskQueuesList',
    taskQueueList: taskQueueList
  }
}
